var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.types),function(type){return _c('div',{key:type,staticClass:"flex flex-row items-center"},[_c('status-chip',{attrs:{"status":_vm.getStatusByType(type)}}),_c('span',{staticClass:"item-text"},[_vm._v(_vm._s(type))])],1)}))}
var staticRenderFns = []

export { render, staticRenderFns }